import { useCallback } from 'react'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_BILLING_BASIC_CHANGE_PLAN } from 'ducks/drawers/types'
import { buildDrawerQueryParam } from 'ducks/drawers/util'
import { BILLING_CYCLE_ANNUAL } from './constants'
import { useBilling } from './hooks'

const SOURCES = [
  'billing_offer',
  'summary_link',
  'reminder',
  'seat_add',
  'trial',
  'bf_billing_offer',
  'bf_reminder',
  'bf_email',
]

export const useOpenAnnualSwitchDrawer = ({
  timing = 'renewal',
  source,
} = {}) => {
  const { currentPricingIds } = useBilling()
  const { drawerId, openDrawer } = useDrawer({
    type: DRAWER_TYPE_BILLING_BASIC_CHANGE_PLAN,
  })

  return useCallback(
    () => {
      openDrawer(currentPricingIds.join('|'), {
        query: {
          ...buildDrawerQueryParam(drawerId, 'drawerProductType', 'inbox'),
          ...buildDrawerQueryParam(
            drawerId,
            'drawerBillingCycle',
            BILLING_CYCLE_ANNUAL
          ),
          ...buildDrawerQueryParam(
            drawerId,
            'drawerAnnualTiming',
            timing === 'now' ? 'now' : 'renewal'
          ),
          ...(SOURCES.includes(source)
            ? buildDrawerQueryParam(drawerId, 'drawerAnnualSource', source)
            : {}),
        },
      })
    },
    [currentPricingIds, drawerId, openDrawer, timing, source]
  )
}
